import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-strikethrough",
  "use": "format-strikethrough-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-strikethrough\"><path fill-rule=\"evenodd\" d=\"M14 19.5v-3h-4v3h4Zm-9-12h5v3h4v-3h5v-3H5v3Zm16 7v-2H3v2h18Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol